module.exports = __webpack_public_path__ + "img/slack.c925af46.png";